import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../../ui/dialog';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Textarea } from '../../ui/textarea';
import { Label } from '../../ui/label';
import { Checkbox } from '../../ui/checkbox';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../ui/select';
import { ISTANBUL_ILCELERI, BUTCE_TERTIBI_KODLARI } from './constants';
import { TesisTuruSecici } from '../../TesisTuruSecici';

export function DTFormDialog({
  open, onOpenChange, editMode, wizardMode, wizardOdenek,
  formData, setFormData, users, firmaList, displayMoney,
  onSubmit, submitting, onCancel,
  addButceTertibi, removeButceTertibi, updateButceTertibi
}) {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(1);

  const toggleGorevli = (name) => {
    const current = formData.piyasa_arastirma_gorevlileri || [];
    if (current.includes(name)) {
      setFormData({ ...formData, piyasa_arastirma_gorevlileri: current.filter(n => n !== name) });
    } else {
      setFormData({ ...formData, piyasa_arastirma_gorevlileri: [...current, name] });
    }
  };

  const handleCancel = () => {
    setCurrentStep(1);
    onCancel();
  };

  const handleSubmit = () => {
    onSubmit();
    setCurrentStep(1);
  };

  return (
    <Dialog open={open} onOpenChange={(val) => { if (!val) { handleCancel(); } else { onOpenChange(true); } }}>
      <DialogContent className="bg-gray-900 border-gray-800 text-white max-w-4xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle data-testid="dt-form-title">
            {editMode ? 'İşi Düzenle' : wizardMode ? 'Ödenekten D.T. Oluştur' : 'Yeni İş Ekle'}
          </DialogTitle>
          <DialogDescription className="text-gray-400">
            {wizardMode
              ? `Ödenek: ${wizardOdenek?.isin_adi || ''} - Adım ${currentStep}/3`
              : editMode ? 'Kayıt bilgilerini düzenleyin' : 'Adım ' + currentStep + '/3'}
          </DialogDescription>
          <div className="flex items-center gap-2 mt-3">
            {[1, 2, 3].map((step) => (
              <div key={step} className="flex items-center gap-2 flex-1">
                <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold transition-colors ${
                  currentStep === step ? 'bg-blue-600 text-white' : currentStep > step ? 'bg-green-600 text-white' : 'bg-gray-700 text-gray-400'
                }`}>
                  {currentStep > step ? (
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" /></svg>
                  ) : step}
                </div>
                <span className={`text-xs hidden md:block ${currentStep >= step ? 'text-white' : 'text-gray-500'}`}>
                  {step === 1 ? 'Temel Bilgiler' : step === 2 ? 'Firma Teklifleri' : 'Sözleşme & Ödeme'}
                </span>
                {step < 3 && <div className={`flex-1 h-0.5 ${currentStep > step ? 'bg-green-600' : 'bg-gray-700'}`} />}
              </div>
            ))}
          </div>
        </DialogHeader>

        {/* STEP 1 */}
        {currentStep === 1 && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 py-4" data-testid="wizard-step-1">
            {wizardMode && (
              <div className="md:col-span-2 bg-emerald-900/20 border border-emerald-700/40 rounded-lg p-3 mb-2">
                <p className="text-xs text-emerald-400">Ödenekten aktarılan bilgiler otomatik dolduruldu. Gerekirse düzenleyebilirsiniz.</p>
              </div>
            )}
            <div className="space-y-2">
              <Label>YIL *</Label>
              <Select value={formData.yil} onValueChange={(value) => setFormData({ ...formData, yil: value })}>
                <SelectTrigger className="bg-gray-800 border-gray-700 text-white"><SelectValue placeholder="Yıl Seç" /></SelectTrigger>
                <SelectContent className="bg-gray-800 border-gray-700 text-white">
                  {[2022, 2023, 2024, 2025, 2026, 2027, 2028].map(year => (
                    <SelectItem key={year} value={year.toString()}>{year}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            <div className="space-y-2">
              <Label>ALIM TÜRÜ</Label>
              <Select value={formData.alim_turu} onValueChange={(value) => setFormData({ ...formData, alim_turu: value })}>
                <SelectTrigger className="bg-gray-800 border-gray-700 text-white"><SelectValue placeholder="Alım Türü Seç" /></SelectTrigger>
                <SelectContent className="bg-gray-800 border-gray-700 text-white">
                  <SelectItem value="dogrudan_temin">Doğrudan Temin</SelectItem>
                  <SelectItem value="acik_ihale">Açık İhale</SelectItem>
                  <SelectItem value="pazarlik">Pazarlık</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div className="space-y-2">
              <Label>İLGİLENEN MEMUR</Label>
              <Select value={formData.ilgilenen_memur} onValueChange={(value) => setFormData({ ...formData, ilgilenen_memur: value })}>
                <SelectTrigger className="bg-gray-800 border-gray-700 text-white"><SelectValue placeholder="Seçiniz" /></SelectTrigger>
                <SelectContent className="bg-gray-800 border-gray-700 text-white">{users.map((u) => (<SelectItem key={u.id} value={u.name}>{u.name}</SelectItem>))}</SelectContent>
              </Select>
            </div>
            <div className="space-y-2 md:col-span-2">
              <Label>PİYASA ARAŞTIRMA GÖREVLİLERİ (Çoklu Seçim)</Label>
              <div className="bg-gray-800 border border-gray-700 rounded-lg p-3 max-h-48 overflow-y-auto">
                <div className="grid grid-cols-2 md:grid-cols-3 gap-2" key={(formData.piyasa_arastirma_gorevlileri || []).join(',')}>
                  {users.map((u) => (
                    <div key={u.id} className="flex items-center space-x-2">
                      <Checkbox id={`gorevli-${u.id}`} checked={(formData.piyasa_arastirma_gorevlileri || []).includes(u.name)} onCheckedChange={() => toggleGorevli(u.name)} className="border-gray-600" />
                      <label htmlFor={`gorevli-${u.id}`} className="text-sm text-gray-300 cursor-pointer">{u.name}</label>
                    </div>
                  ))}
                </div>
              </div>
              {(formData.piyasa_arastirma_gorevlileri || []).length > 0 && (
                <div className="mt-2 flex flex-wrap gap-1">
                  {(formData.piyasa_arastirma_gorevlileri || []).map((name) => (
                    <span key={name} className="inline-flex items-center gap-1 px-2 py-1 bg-blue-900/30 text-blue-300 text-xs rounded">
                      {name}
                      <button type="button" onClick={() => toggleGorevli(name)} className="hover:text-blue-100">x</button>
                    </span>
                  ))}
                </div>
              )}
              <p className="text-xs text-gray-400 mt-1">Secili: {(formData.piyasa_arastirma_gorevlileri || []).length} gorevli</p>
            </div>
            <div className="space-y-2">
              <Label>İLÇE</Label>
              <Select value={formData.ilce} onValueChange={(value) => setFormData({ ...formData, ilce: value })}>
                <SelectTrigger className="bg-gray-800 border-gray-700 text-white"><SelectValue placeholder="İlçe seçin" /></SelectTrigger>
                <SelectContent className="bg-gray-800 border-gray-700 text-white max-h-60">{ISTANBUL_ILCELERI.map((ilce) => (<SelectItem key={ilce} value={ilce}>{ilce}</SelectItem>))}</SelectContent>
              </Select>
            </div>
            <div className="space-y-2">
              <Label>TESİS TÜRÜ * (çoklu seçim)</Label>
              <TesisTuruSecici value={formData.tesis_turu} onChange={(codes) => setFormData({ ...formData, tesis_turu: codes })} testId="dt-tesis-turu-secici" />
            </div>
            <div className="space-y-2 md:col-span-2">
              <Label>İŞİN ADI *</Label>
              <Textarea value={formData.isin_adi} onChange={(e) => setFormData({ ...formData, isin_adi: e.target.value })} className="bg-gray-800 border-gray-700 text-white" rows={3} required />
            </div>
            {wizardMode && (
              <>
                <div className="space-y-2">
                  <Label>TALEP YERİ</Label>
                  <Input value={formData.talep_yeri} onChange={(e) => setFormData({ ...formData, talep_yeri: e.target.value })} className="bg-gray-800 border-gray-700 text-white" />
                </div>
                <div className="space-y-2">
                  <Label>ÖDENEK TUTARI</Label>
                  <Input value={formData.odenek_tutari} readOnly className="bg-gray-800/50 border-gray-700 text-emerald-400 font-semibold cursor-not-allowed" />
                  {formData.odenek_tutari && <p className="text-xs text-gray-400">Gorünum: {displayMoney(formData.odenek_tutari)}</p>}
                </div>
              </>
            )}
          </div>
        )}

        {/* STEP 2 */}
        {currentStep === 2 && (
          <div className="space-y-4 py-4" data-testid="wizard-step-2">
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-medium text-blue-400">Teklif Veren Firmalar</h3>
              {firmaList.length > 0 && <span className="text-xs text-gray-500">{firmaList.length} kayitli firma</span>}
            </div>
            {[
              { num: 1, adiKey: 'firma1_adi', teklifKey: 'firma1_teklif' },
              { num: 2, adiKey: 'firma2_adi', teklifKey: 'firma2_teklif' },
              { num: 3, adiKey: 'firma3_adi', teklifKey: 'firma3_teklif' },
              { num: 4, adiKey: 'firma4_adi', teklifKey: 'firma4_teklif' },
            ].map(({ num, adiKey, teklifKey }) => (
              <div key={num} className="grid grid-cols-1 md:grid-cols-2 gap-3 bg-blue-900/10 p-4 rounded-lg border border-blue-700/30">
                <div className="space-y-2">
                  <Label>{num}. Firma Adi</Label>
                  {firmaList.length > 0 ? (
                    <Select value={formData[adiKey]} onValueChange={(value) => setFormData({ ...formData, [adiKey]: value })}>
                      <SelectTrigger className="bg-gray-800 border-gray-700 text-white" data-testid={`select-${adiKey}`}><SelectValue placeholder="Firma secin" /></SelectTrigger>
                      <SelectContent className="bg-gray-800 border-gray-700 text-white max-h-60">
                        {firmaList.map((f) => (<SelectItem key={f.id} value={f.firma_adi}>{f.firma_adi}</SelectItem>))}
                      </SelectContent>
                    </Select>
                  ) : (
                    <Input value={formData[adiKey]} onChange={(e) => setFormData({ ...formData, [adiKey]: e.target.value })} className="bg-gray-800 border-gray-700 text-white" placeholder="Firma adi" />
                  )}
                </div>
                <div className="space-y-2">
                  <Label>{num}. Firma Teklif (KDV Haric)</Label>
                  <Input value={formData[teklifKey]} onChange={(e) => setFormData({ ...formData, [teklifKey]: e.target.value.replace(/[^0-9,]/g, '') })} className="bg-gray-800 border-gray-700 text-white" placeholder="50000,00" />
                  {formData[teklifKey] && (<p className="text-xs text-gray-400">Gorünum: {displayMoney(formData[teklifKey])}</p>)}
                </div>
              </div>
            ))}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
              <div className="space-y-2">
                <Label>ISI YAPAN FIRMA *</Label>
                {firmaList.length > 0 ? (
                  <Select value={formData.isi_yapan_firma} onValueChange={(value) => setFormData({ ...formData, isi_yapan_firma: value })}>
                    <SelectTrigger className="bg-gray-800 border-gray-700 text-white" data-testid="select-isi-yapan-firma"><SelectValue placeholder="Firma secin" /></SelectTrigger>
                    <SelectContent className="bg-gray-800 border-gray-700 text-white max-h-60">
                      {firmaList.map((f) => (<SelectItem key={f.id} value={f.firma_adi}>{f.firma_adi}</SelectItem>))}
                    </SelectContent>
                  </Select>
                ) : (
                  <Input value={formData.isi_yapan_firma} onChange={(e) => setFormData({ ...formData, isi_yapan_firma: e.target.value })} className="bg-gray-800 border-gray-700 text-white" required />
                )}
              </div>
              <div className="flex items-end">
                <Button onClick={() => navigate('/bakim-onarim/firma-bilgileri')} type="button" variant="outline" className="bg-amber-900/20 border-amber-700/50 text-amber-400 hover:bg-amber-900/40" data-testid="manage-firms-btn">
                  <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" /></svg>
                  Firma Yonet
                </Button>
              </div>
            </div>
          </div>
        )}

        {/* STEP 3 */}
        {currentStep === 3 && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 py-4" data-testid="wizard-step-3">
            <div className="space-y-2">
              <Label>SÖZLEŞME BEDELİ (KDV HARİÇ)</Label>
              <Input value={formData.sozlesme_bedeli} onChange={(e) => setFormData({ ...formData, sozlesme_bedeli: e.target.value.replace(/[^0-9,]/g, '') })} className="bg-gray-800 border-gray-700 text-white" placeholder="65000,00" />
              {formData.sozlesme_bedeli && (<p className="text-xs text-gray-400">Gorünum: {displayMoney(formData.sozlesme_bedeli)}</p>)}
            </div>
            <div className="space-y-2">
              <Label>İŞİN SÜRESİ (Gün)</Label>
              <Input type="number" value={formData.isin_suresi} onChange={(e) => setFormData({ ...formData, isin_suresi: e.target.value })} className="bg-gray-800 border-gray-700 text-white" placeholder="30" />
            </div>
            <div className="space-y-2">
              <Label>ÖDEME TARİHİ</Label>
              <Input type="date" value={formData.odeme_tarihi} onChange={(e) => setFormData({ ...formData, odeme_tarihi: e.target.value })} className="bg-gray-800 border-gray-700 text-white" />
            </div>
            <div className="space-y-2">
              <Label>ÖDEME BELGE NO</Label>
              <Input value={formData.odeme_belge_no} onChange={(e) => setFormData({ ...formData, odeme_belge_no: e.target.value })} className="bg-gray-800 border-gray-700 text-white" />
            </div>
            <div className="space-y-2">
              <Label>ÖDENEN TUTAR</Label>
              <Input value={formData.odenen_tutar} onChange={(e) => setFormData({ ...formData, odenen_tutar: e.target.value.replace(/[^0-9,]/g, '') })} className="bg-gray-800 border-gray-700 text-white" placeholder="65000,00" />
              {formData.odenen_tutar && (<p className="text-xs text-gray-400">Gorünum: {displayMoney(formData.odenen_tutar)}</p>)}
            </div>
            <div className="col-span-2 space-y-3 p-4 bg-blue-900/20 border border-blue-700/50 rounded">
              <div className="flex items-center justify-between">
                <Label className="font-medium">BÜTÇE TERTİBİ</Label>
                <Button type="button" onClick={addButceTertibi} size="sm" className="bg-blue-600 hover:bg-blue-700 h-8">+ Ekle</Button>
              </div>
              {formData.butce_tertibi_list?.map((tertibi, i) => (
                <div key={i} className="flex gap-2">
                  <Select value={tertibi} onValueChange={(v) => updateButceTertibi(i, v)} className="flex-1">
                    <SelectTrigger className="bg-gray-800 border-gray-700 text-white"><SelectValue placeholder="Seç" /></SelectTrigger>
                    <SelectContent className="bg-gray-800 border-gray-700 text-white max-h-60">
                      {BUTCE_TERTIBI_KODLARI.map((k) => (<SelectItem key={k} value={k}>{k}</SelectItem>))}
                    </SelectContent>
                  </Select>
                  <Button type="button" onClick={() => removeButceTertibi(i)} size="sm" variant="outline" className="bg-red-900/30 border-red-700 text-red-400">x</Button>
                </div>
              ))}
              {(!formData.butce_tertibi_list || formData.butce_tertibi_list.length === 0) && (
                <p className="text-xs text-gray-500 italic">+ Ekle butonuna tıklayın</p>
              )}
            </div>
          </div>
        )}

        <DialogFooter className="flex justify-between">
          <div className="flex gap-2">
            <Button onClick={handleCancel} variant="ghost" className="text-gray-400">İptal</Button>
          </div>
          <div className="flex gap-2">
            {currentStep > 1 && (
              <Button onClick={() => setCurrentStep(currentStep - 1)} variant="outline" className="bg-gray-800 border-gray-700 text-white hover:bg-gray-700" data-testid="wizard-prev-btn">Geri</Button>
            )}
            {currentStep < 3 ? (
              <Button onClick={() => setCurrentStep(currentStep + 1)} className="bg-blue-600 hover:bg-blue-700 text-white" data-testid="wizard-next-btn">İleri</Button>
            ) : (
              <Button onClick={handleSubmit} disabled={submitting} className="bg-blue-600 hover:bg-blue-700 text-white" data-testid="wizard-submit-btn">
                {submitting ? 'Kaydediliyor...' : (editMode ? 'Güncelle' : 'Kaydet')}
              </Button>
            )}
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
